module.exports = __webpack_public_path__ + "media/images/markers/mobile-2x-bebfe8805a4dd2a29f36f1867749960f.png";